import axios from 'axios';
import { loadTranslations } from 'react-redux-i18n-lite';

import { API_BACKOFFICE_CUSTOMER_TRANSLATIONS } from '../services/api/apiConst';
import { translationsObject } from '../services/translate/translateService';
import { PARAMS } from '../const';

export let getCustomerTranslations = () => {
  return (dispatch, getState) => {
    const translations = translationsObject();
    const customerId = getState().account.configuration.customerId;

    if (!customerId) {
      setTimeout(() => {
        dispatch(getCustomerTranslations());
      }, 1000);
      return;
    }

    axios
      .get(API_BACKOFFICE_CUSTOMER_TRANSLATIONS.replace(PARAMS.CUSTOMER, customerId))
      .then(res => {
        const customerTranslation = (res && res.data && res.data.values) || null;

        if (!customerTranslation) {
          dispatch(loadTranslations(translations));
          return;
        }

        const customerTranslationEn = customerTranslation.en;
        const customerTranslationEs = customerTranslation.es;
        const customerTranslationEsAr = customerTranslation['es-ar'];
        const customerTranslationEsMx = customerTranslation['es-mx'];
        const customerTranslationEsCo = customerTranslation['es-co'];
        const customerTranslationEsEc = customerTranslation['es-ec'];
        const customerTranslationEsPe = customerTranslation['es-pe'];
        const customerTranslationEsBo = customerTranslation['es-bo'];
        const customerTranslationEsPr = customerTranslation['es-pr'];
        const customerTranslationDe = customerTranslation.de;
        const customerTranslationGl = customerTranslation.gl;
        const customerTranslationPtBr = customerTranslation['pt-br'];

        const en = modifyTranslations(translations.en, customerTranslationEn);
        const es = modifyTranslations(translations.es, customerTranslationEs);
        const esAr = modifyTranslations(translations['es-ar'], customerTranslationEsAr);
        const esMx = modifyTranslations(translations['es-mx'], customerTranslationEsMx);
        const esCo = modifyTranslations(translations['es-co'], customerTranslationEsCo);
        const esEc = modifyTranslations(translations['es-ec'], customerTranslationEsEc);
        const esPe = modifyTranslations(translations['es-pe'], customerTranslationEsPe);
        const esBo = modifyTranslations(translations['es-bo'], customerTranslationEsBo);
        const esPr = modifyTranslations(translations['es-pr'], customerTranslationEsPr);
        const de = modifyTranslations(translations.de, customerTranslationDe);
        const gl = modifyTranslations(translations.gl, customerTranslationGl);
        const ptBr = modifyTranslations(translations['pt-br'], customerTranslationPtBr);

        dispatch(
          loadTranslations({
            en,
            es,
            'es-ar': esAr,
            'es-mx': esMx,
            'es-co': esCo,
            'es-ec': esEc,
            'es-pe': esPe,
            'es-bo': esBo,
            'es-pr': esPr,
            de,
            gl,
            'pt-br': ptBr
          })
        );
      })
      .catch(err => {
        console.error(err);
      });
  };
};

function modifyTranslations(translation, customerTranslation) {
  const translationObj = translation;
  const customerTranslationObj = customerTranslation;

  function modifyProperties(obj, path, value) {
    const properties = path.split('/');
    const property = properties.shift();

    if (properties.length === 0) {
      obj[property] = value;
      return;
    }

    if (!obj[property]) {
      obj[property] = {};
    }

    modifyProperties(obj[property], properties.join('/'), value);
  }

  if (!customerTranslationObj) {
    return translationObj;
  }

  for (let path in customerTranslationObj) {
    if (customerTranslationObj.hasOwnProperty(path)) {
      modifyProperties(translationObj, path, customerTranslationObj[path]);
    }
  }

  return translationObj;
}
